import React from "react";
import { Color } from "src/utils";

interface Props {
	name: IconType;
	color?: Color | string;
	size?: number;
}

export type IconType =
	| "logo"

	// Sidebar
	| "workbench"
	| "freezer"
	| "bays"
	| "logout"

	// General
	| "infoWarning"
	| "infoSuccess"

	// Pagination
	| "paginationRight"

	// Inputs
	| "search"
	| "clear"
	| "dropdown"
	| "email"
	| "eyeOn"
	| "eyeOff"
	| "expandDown"
	| "expandUp"
	| "zoomIn"
	| "zoomOut"
	| "checkmark"
	| "delete"
	| "filter"
	| "arrange"

	// Checkboxes
	| "checkboxOn"
	| "checkboxOff"

	// Modal
	| "close"
	| "maximize"
	| "shrink"
	| "modalAlert"

	// Inputs
	| "remove"
	| "add"

	// Toasts
	| "toastSuccess"
	| "toastPending"
	| "toastWarning"
	| "toastError"

	// Loading
	| "loadingInline"

	// Files
	| "fileCSV"

	// Small
	| "info"

	// General.
	| "settings"
	| "picture"
	| "tooltip"
	| "mudmap"
	| "planogram"
	| "pogger"
	| "segment"
	| "merchant"
	| "rotate";

export const IconV2: React.FC<Props> = ({ name, color, size }) => {
	const colorOrPrimary = color || Color.primary;

	switch (name) {
		case "logo":
			return (
				<svg
					width="54"
					height="41"
					viewBox="0 0 54 41"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M0.408 36.176C0.408 35.5893 0.517333 35.08 0.736 34.648C0.96 34.2107 1.28 33.872 1.696 33.632C2.112 33.392 2.60533 33.272 3.176 33.272C3.74667 33.272 4.24 33.392 4.656 33.632C5.072 33.872 5.392 34.2107 5.616 34.648C5.84533 35.08 5.96 35.5867 5.96 36.168C5.96 36.76 5.84533 37.2747 5.616 37.712C5.392 38.144 5.072 38.4827 4.656 38.728C4.24 38.968 3.74667 39.088 3.176 39.088C2.60533 39.088 2.112 38.968 1.696 38.728C1.28533 38.4827 0.968 38.1413 0.744 37.704C0.52 37.2667 0.408 36.7573 0.408 36.176ZM1.712 36.176C1.712 36.56 1.76533 36.8933 1.872 37.176C1.97867 37.4533 2.14133 37.6667 2.36 37.816C2.57867 37.96 2.85067 38.032 3.176 38.032C3.656 38.032 4.02133 37.8693 4.272 37.544C4.52267 37.2133 4.648 36.7573 4.648 36.176C4.648 35.7867 4.592 35.4533 4.48 35.176C4.37333 34.8987 4.208 34.688 3.984 34.544C3.76533 34.4 3.496 34.328 3.176 34.328C2.68533 34.328 2.31733 34.4907 2.072 34.816C1.832 35.136 1.712 35.5893 1.712 36.176ZM6.86338 39V33.36H7.95938L9.91938 37.76H9.66338L11.6234 33.36H12.7114V39H11.5754V35.168H11.8954L10.1434 39H9.42338L7.66338 35.168H7.99938V39H6.86338ZM13.791 39V33.36H14.719L17.783 37.256H17.567V33.36H18.727V39H17.799L14.743 35.104H14.951V39H13.791ZM19.7891 39V33.36H21.0371V39H19.7891ZM24.0278 39.064C23.5744 39.064 23.1798 39.0053 22.8438 38.888C22.5078 38.7653 22.2064 38.5893 21.9398 38.36L22.1078 38.072C22.3051 38.2267 22.4944 38.3547 22.6758 38.456C22.8571 38.552 23.0544 38.624 23.2678 38.672C23.4864 38.7147 23.7371 38.736 24.0198 38.736C24.5424 38.736 24.9371 38.632 25.2038 38.424C25.4758 38.2107 25.6118 37.928 25.6118 37.576C25.6118 37.2773 25.5158 37.048 25.3238 36.888C25.1371 36.728 24.8144 36.6027 24.3558 36.512L23.5638 36.352C23.0464 36.2453 22.6624 36.0773 22.4118 35.848C22.1611 35.6187 22.0358 35.3013 22.0358 34.896C22.0358 34.576 22.1184 34.296 22.2838 34.056C22.4491 33.816 22.6784 33.6293 22.9718 33.496C23.2651 33.3627 23.6064 33.296 23.9958 33.296C24.3904 33.296 24.7504 33.3573 25.0758 33.48C25.4011 33.6027 25.6811 33.7867 25.9158 34.032L25.7558 34.32C25.4944 34.0693 25.2251 33.8907 24.9478 33.784C24.6704 33.6773 24.3531 33.624 23.9958 33.624C23.5051 33.624 23.1131 33.7387 22.8198 33.968C22.5318 34.1973 22.3878 34.5067 22.3878 34.896C22.3878 35.2107 22.4811 35.456 22.6678 35.632C22.8544 35.8027 23.1558 35.9307 23.5718 36.016L24.3718 36.176C24.9264 36.288 25.3291 36.4507 25.5798 36.664C25.8358 36.872 25.9638 37.1733 25.9638 37.568C25.9638 37.8613 25.8864 38.1227 25.7318 38.352C25.5771 38.576 25.3531 38.752 25.0598 38.88C24.7718 39.0027 24.4278 39.064 24.0278 39.064ZM28.3307 39V33.672H26.2347V33.36H30.7627V33.672H28.6667V39H28.3307ZM31.5694 39V33.36H33.7294C34.3001 33.36 34.7428 33.4933 35.0574 33.76C35.3721 34.0267 35.5294 34.4027 35.5294 34.888C35.5294 35.2027 35.4574 35.472 35.3134 35.696C35.1694 35.9147 34.9721 36.0827 34.7214 36.2C34.4761 36.312 34.1934 36.368 33.8734 36.368L34.0414 36.304H34.1054C34.3188 36.304 34.5081 36.3547 34.6734 36.456C34.8441 36.552 34.9801 36.728 35.0814 36.984L35.8574 39H35.4814L34.7774 37.112C34.6708 36.8187 34.5134 36.632 34.3054 36.552C34.1028 36.4667 33.8388 36.424 33.5134 36.424H31.9054V39H31.5694ZM31.9054 36.112H33.6974C34.1774 36.112 34.5428 36.008 34.7934 35.8C35.0441 35.5867 35.1694 35.2827 35.1694 34.888C35.1694 34.4933 35.0441 34.192 34.7934 33.984C34.5428 33.776 34.1774 33.672 33.6974 33.672H31.9054V36.112ZM36.9582 39V33.36H40.3822V33.672H37.2942V35.984H40.2062V36.296H37.2942V38.688H40.3822V39H36.9582ZM40.9133 39L43.3373 33.36H43.6653L46.1373 39H45.7693L45.0573 37.368L45.2413 37.44H41.7453L41.9693 37.368L41.2733 39H40.9133ZM43.4893 33.808L42.0573 37.176L41.8813 37.128H45.1053L44.9773 37.176L43.5053 33.808H43.4893ZM47.1029 39V33.36H47.3989L49.8309 38.864H49.6069L52.0469 33.36H52.3349V39H52.0229V33.688H52.2149L49.8629 39H49.5829L47.2229 33.68H47.4149V39H47.1029Z"
						fill="#001A13"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M33.2261 2.95874C34.3932 2.95874 35.3695 3.27752 36.0459 3.95388C36.9491 4.85745 37.2126 6.29685 36.9326 8.011C36.8645 8.42661 36.7642 8.85829 36.6334 9.30255C36.3562 10.2446 35.941 11.2425 35.3999 12.2621C35.1839 12.6686 34.9507 13.0779 34.6956 13.4887C34.5334 13.7505 34.3611 14.0126 34.1832 14.2744C34.1898 14.0182 34.1933 13.7602 34.1933 13.5002C34.1933 13.2331 34.1894 12.9682 34.1825 12.7053C34.1615 11.9133 34.1087 11.1401 34.0276 10.3893C33.942 9.59337 33.8228 8.82403 33.6749 8.0844C33.5767 7.5947 33.4659 7.11862 33.3429 6.65688C32.9867 5.32478 32.5298 4.11502 31.988 3.06605C32.4194 2.99544 32.8339 2.95874 33.2261 2.95874Z"
						fill={Color.primary}
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M26.5 0C27.7773 0 28.9811 0.831557 29.9951 2.24125C30.2408 2.58276 30.4747 2.95851 30.6963 3.36433C31.1657 4.22525 31.5775 5.22284 31.9155 6.32494C32.0521 6.7706 32.1783 7.23165 32.2898 7.70947C32.359 8.00553 32.4216 8.30858 32.4803 8.61548C32.3031 8.42882 32.1235 8.24322 31.9399 8.06006C31.7564 7.8762 31.5715 7.69619 31.3856 7.51967C30.8039 6.96704 30.2132 6.45217 29.6179 5.97295C28.9965 5.47241 28.3701 5.01416 27.7441 4.59681C27.3285 4.31962 26.9136 4.06131 26.5 3.82223C25.3071 3.13188 24.1291 2.59988 23.0046 2.24125C24.0187 0.831208 25.2228 0 26.5 0Z"
						fill={Color.primary}
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M16.9538 3.95388C17.6301 3.27752 18.606 2.95874 19.7739 2.95874C20.166 2.95874 20.5802 2.99544 21.0116 3.0657C21.4272 3.13386 21.8589 3.23348 22.3035 3.36421C23.243 3.64104 24.2389 4.05735 25.2557 4.59669C25.6678 4.8155 26.0834 5.05563 26.5001 5.31429C26.7577 5.47438 27.0153 5.64146 27.2733 5.81658C27.0174 5.80994 26.7594 5.80645 26.5001 5.80645C26.2404 5.80645 25.9824 5.80994 25.7265 5.81658C24.9243 5.83721 24.1421 5.89069 23.3822 5.97283C22.5887 6.05847 21.8218 6.17731 21.0843 6.32482C20.5946 6.42304 20.1182 6.53384 19.6568 6.65688C18.325 7.01271 17.1159 7.46921 16.0673 8.011C15.7873 6.2965 16.0505 4.8571 16.9538 3.95388Z"
						fill={Color.primary}
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M13 13.5001C13 12.2225 13.8316 11.0187 15.2416 10.0043C15.5835 9.75858 15.9599 9.52439 16.3664 9.30243C17.227 8.83335 18.2235 8.42229 19.3249 8.08428C19.771 7.94761 20.2316 7.82143 20.7095 7.70958C21.0052 7.64072 21.3082 7.5785 21.6144 7.51978C21.4288 7.69629 21.2436 7.87631 21.0601 8.06017C20.8762 8.24367 20.6962 8.42858 20.5197 8.61454C19.967 9.19617 19.4522 9.78725 18.9726 10.3825C18.4724 11.004 18.0142 11.63 17.5972 12.2561C17.32 12.6717 17.0617 13.0866 16.8226 13.5001C16.1326 14.693 15.6002 15.871 15.2416 16.9955C13.8316 15.9815 13 14.7773 13 13.5001Z"
						fill={Color.primary}
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M16.9539 23.0457C16.0507 22.1425 15.7871 20.703 16.0675 18.9885C16.1353 18.5729 16.2356 18.1413 16.3663 17.697C16.6432 16.7567 17.0574 15.7612 17.5971 14.7437C17.8155 14.3316 18.0522 13.9164 18.3112 13.4997C18.4713 13.2421 18.6415 12.9838 18.8163 12.7258C18.81 12.982 18.8065 13.24 18.8065 13.5001C18.8065 13.7598 18.81 14.0177 18.8163 14.2739C18.8372 15.0754 18.8907 15.8577 18.9729 16.6176C19.0585 17.4107 19.1773 18.1776 19.3248 18.9151C19.4227 19.4049 19.5335 19.8809 19.6569 20.3423C20.0134 21.6779 20.4717 22.8901 21.0152 23.9408C19.2465 24.2292 17.8362 23.9276 16.9539 23.0457Z"
						fill={Color.primary}
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M26.4998 26.9999C25.2181 26.9999 24.01 26.1631 22.9939 24.7443C22.7538 24.4091 22.5248 24.0411 22.3078 23.644C21.8363 22.781 21.4231 21.7806 21.084 20.6746C20.947 20.2286 20.8208 19.7676 20.7093 19.2901C20.6405 18.9944 20.5779 18.6917 20.5195 18.3855C20.696 18.5715 20.8761 18.7564 21.0599 18.9399C21.2431 19.1234 21.4287 19.303 21.6153 19.4803C22.1931 20.0287 22.7863 20.5443 23.3889 21.0277C24.0097 21.5254 24.6403 21.9879 25.2757 22.4091C25.6826 22.6789 26.0909 22.9334 26.4998 23.1693C27.618 23.8139 28.739 24.3287 29.833 24.6933C29.8914 24.7129 29.9473 24.7258 30.0054 24.7443C28.9892 26.1631 27.7816 26.9999 26.4998 26.9999Z"
						fill={Color.primary}
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M36.0458 23.0456C35.1639 23.9275 33.7531 24.2291 31.9848 23.9408C31.5724 23.8733 31.141 23.7754 30.6915 23.6436C30.5402 23.5993 30.3867 23.5514 30.2312 23.4996C29.4087 23.2256 28.5681 22.8575 27.7243 22.4087C27.3164 22.192 26.9077 21.9568 26.5002 21.7026C26.2345 21.537 25.9696 21.3629 25.7053 21.1822C25.9682 21.1892 26.2331 21.193 26.5002 21.193C26.7669 21.193 27.0318 21.1892 27.295 21.1822C28.0871 21.1612 28.8599 21.1084 29.6111 21.0273C30.4066 20.9417 31.176 20.8225 31.9156 20.6746C32.4053 20.5768 32.8814 20.466 33.3428 20.3426C34.678 19.9857 35.8902 19.5278 36.941 18.9846C37.2293 20.7529 36.9277 22.1637 36.0458 23.0456Z"
						fill={Color.primary}
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M37.7466 17.0043C37.4111 17.2448 37.042 17.4744 36.6442 17.6918C35.7812 18.1634 34.7808 18.5765 33.6752 18.9156C33.2288 19.0526 32.7681 19.1788 32.2903 19.2903C31.9946 19.3595 31.6916 19.4217 31.385 19.4804C31.5713 19.3032 31.7569 19.1236 31.9404 18.9401C32.1239 18.7565 32.304 18.5716 32.4801 18.386C33.0327 17.8047 33.548 17.2137 34.0272 16.6184C34.5312 15.992 34.9926 15.3608 35.4124 14.7302C35.6844 14.3216 35.9381 13.9137 36.1734 13.5071C36.8655 12.3117 37.3992 11.1313 37.7585 10.0044C39.1686 11.0184 40.0001 12.2226 40.0001 13.5002C40.0001 14.7812 39.164 15.9885 37.7466 17.0043Z"
						fill={Color.primary}
					/>
				</svg>
			);

		// Sidebar
		case "workbench":
			return (
				<svg
					width={size || 18}
					height={size || 18}
					viewBox="0 0 18 18"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M16 8.3V6.9C16 3.4 14.6 2 11.1 2H6.9C3.4 2 2 3.4 2 6.9V11.1C2 14.6 3.4 16 6.9 16H7.6"
						stroke={colorOrPrimary}
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M2.02103 6.55005H16"
						stroke={colorOrPrimary}
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M2.02103 11.45H9.00003"
						stroke={colorOrPrimary}
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M6.55701 15.9931V2.00708"
						stroke={colorOrPrimary}
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M11.457 8.99307V2.00708"
						stroke={colorOrPrimary}
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M11.1 12.2658V13.8038C11.1 14.3689 11.1 14.3689 11.6331 14.7287L13.0991 15.5763C13.3204 15.7043 13.6802 15.7043 13.8988 15.5763L15.3648 14.7287C15.8979 14.3689 15.8979 14.3689 15.8979 13.8064V12.2658C15.8979 11.7033 15.8979 11.7033 15.3648 11.3435L13.8988 10.4959C13.6802 10.3679 13.3204 10.3679 13.0991 10.4959L11.6331 11.3435C11.1 11.7033 11.1 11.7033 11.1 12.2658Z"
						stroke={colorOrPrimary}
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M13.499 13.8359C13.9406 13.8359 14.2986 13.4779 14.2986 13.0362C14.2986 12.5946 13.9406 12.2366 13.499 12.2366C13.0573 12.2366 12.6993 12.5946 12.6993 13.0362C12.6993 13.4779 13.0573 13.8359 13.499 13.8359Z"
						stroke={colorOrPrimary}
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
			);

		case "freezer":
			return (
				<svg
					width={size || 18}
					height={size || 18}
					viewBox="0 0 18 18"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M16 5.5H2C1.17157 5.5 0.5 6.17157 0.5 7V16C0.5 16.8284 1.17157 17.5 2 17.5H16C16.8284 17.5 17.5 16.8284 17.5 16V7C17.5 6.17157 16.8284 5.5 16 5.5Z"
						stroke={colorOrPrimary}
						strokeLinejoin="round"
					/>
					<path
						d="M12.5516 13.2311L11.9281 12.8693C12.1552 12.6325 12.4284 12.519 12.4323 12.5171C12.5766 12.4593 12.6517 12.2977 12.6036 12.1495C12.567 12.036 12.4612 11.9609 12.3438 11.9609C12.3072 11.9609 12.2726 11.9686 12.2379 11.9821C12.2187 11.9898 11.7683 12.1745 11.4316 12.5825L9.57831 11.5048L11.4316 10.4271C11.7683 10.8351 12.2167 11.0198 12.2379 11.0275C12.2726 11.041 12.3072 11.0487 12.3438 11.0487C12.4612 11.0487 12.567 10.9717 12.6036 10.8601C12.6517 10.7119 12.5766 10.5503 12.4323 10.4925C12.4304 10.4906 12.1571 10.3771 11.9281 10.1404L12.5516 9.77857C12.6902 9.69774 12.7364 9.52069 12.6575 9.38213C12.6055 9.29168 12.5093 9.23587 12.4053 9.23587C12.3553 9.23587 12.3034 9.24934 12.2591 9.27436L11.6394 9.63616C11.5528 9.32439 11.5874 9.03187 11.5894 9.02033C11.6105 8.86445 11.5105 8.72011 11.3584 8.68739C11.3392 8.68355 11.3199 8.68162 11.3007 8.68162C11.1641 8.68162 11.0505 8.78169 11.0294 8.92025C11.0255 8.94142 10.9601 9.42062 11.1467 9.92483L9.29926 11.0025V9.09346C9.81694 9.00301 10.1999 8.70471 10.2172 8.69124C10.2769 8.64313 10.3154 8.57578 10.3212 8.4988C10.3269 8.42182 10.3038 8.34869 10.2519 8.29095C10.1961 8.22937 10.1172 8.19281 10.0325 8.19281C9.96705 8.19281 9.90162 8.2159 9.84966 8.25631C9.84773 8.25824 9.61487 8.43721 9.29926 8.51804V7.79059C9.29926 7.63279 9.16262 7.5 9.00097 7.5C8.83931 7.5 8.70268 7.63279 8.70268 7.79059V8.51227C8.38899 8.43144 8.15613 8.25247 8.15228 8.25054C8.10032 8.21013 8.03681 8.18703 7.96946 8.18703C7.88478 8.18703 7.80588 8.2236 7.75007 8.28518C7.69811 8.34292 7.67309 8.41989 7.68079 8.49495C7.68656 8.57 7.72505 8.63736 7.78471 8.68547C7.80203 8.69894 8.185 8.99723 8.70268 9.08768V10.9968L6.85519 9.91905C7.03994 9.41869 6.97451 8.93565 6.97066 8.91448C6.95141 8.77592 6.83787 8.67585 6.70123 8.67585C6.68199 8.67585 6.66274 8.67777 6.6435 8.68162C6.49147 8.71241 6.38947 8.8606 6.41256 9.01455C6.41256 9.0184 6.45105 9.31285 6.36253 9.62846L5.74093 9.27051C5.69666 9.24549 5.64663 9.23202 5.59467 9.23202C5.49074 9.23202 5.39452 9.28783 5.34256 9.37828C5.26366 9.51684 5.30985 9.69581 5.44841 9.77472L6.07193 10.1365C5.84677 10.3694 5.57735 10.4848 5.56772 10.4887C5.42339 10.5464 5.34833 10.7081 5.39645 10.8563C5.43301 10.9698 5.53886 11.0449 5.65625 11.0449C5.69281 11.0449 5.72745 11.0372 5.76209 11.0237C5.78134 11.016 6.23166 10.8312 6.56845 10.4233L8.4217 11.501L6.56845 12.5787C6.23166 12.1707 5.78326 11.9859 5.76209 11.9782C5.72745 11.9648 5.69281 11.9571 5.65625 11.9571C5.53886 11.9571 5.43301 12.034 5.39645 12.1457C5.34833 12.2938 5.42339 12.4536 5.56772 12.5132C5.57735 12.5171 5.84677 12.6325 6.07193 12.8654L5.44841 13.2272C5.30985 13.308 5.26366 13.4851 5.34256 13.6236C5.39452 13.7141 5.49074 13.7699 5.59467 13.7699C5.6447 13.7699 5.69666 13.7564 5.74093 13.7314L6.36253 13.3696C6.45105 13.6872 6.41256 13.9816 6.41256 13.9854C6.38947 14.1394 6.49147 14.2876 6.6435 14.3184C6.66274 14.3222 6.68199 14.3242 6.70123 14.3242C6.83787 14.3242 6.95141 14.2241 6.97258 14.0855C6.97643 14.0643 7.04186 13.5852 6.85519 13.0809L8.70268 12.0032V13.9123C8.185 14.0028 7.80203 14.3011 7.78471 14.3145C7.72505 14.3626 7.68656 14.43 7.68079 14.507C7.67501 14.584 7.69811 14.6571 7.75007 14.7148C7.80588 14.7764 7.88478 14.813 7.96946 14.813C8.03489 14.813 8.10032 14.7899 8.15228 14.7495C8.1542 14.7475 8.38899 14.5686 8.70268 14.4877V15.2094C8.70268 15.3672 8.83931 15.5 9.00097 15.5C9.16262 15.5 9.29926 15.3672 9.29926 15.2094V14.4877C9.61295 14.5686 9.84581 14.7475 9.84966 14.7495C9.90162 14.7899 9.96705 14.813 10.0325 14.813C10.1172 14.813 10.1961 14.7764 10.2519 14.7148C10.3038 14.6571 10.3288 14.5801 10.3212 14.5051C10.3154 14.43 10.2769 14.3626 10.2172 14.3145C10.1999 14.3011 9.81694 14.0028 9.29926 13.9123V12.0032L11.1467 13.0809C10.962 13.5813 11.0274 14.0643 11.0313 14.0855C11.0505 14.2241 11.1641 14.3242 11.3007 14.3242C11.3199 14.3242 11.3392 14.3222 11.3584 14.3184C11.5105 14.2876 11.6105 14.1413 11.5894 13.9854C11.5874 13.9758 11.5528 13.6833 11.6394 13.3696L12.2591 13.7314C12.3034 13.7564 12.3534 13.7699 12.4053 13.7699C12.5093 13.7699 12.6055 13.7141 12.6575 13.6236C12.7364 13.4909 12.6902 13.3119 12.5516 13.2311Z"
						fill={colorOrPrimary}
						stroke={colorOrPrimary}
						strokeWidth="0.3"
					/>
					<path
						d="M17 3.5C17.2761 3.5 17.5 3.27614 17.5 3V2C17.5 1.17157 16.8284 0.5 16 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V3C0.5 3.27614 0.723858 3.5 1 3.5H17Z"
						stroke={colorOrPrimary}
						strokeLinejoin="round"
					/>
				</svg>
			);

		case "bays":
			return (
				<svg
					width={size || 18}
					height={size || 18}
					viewBox="0 0 18 18"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path d="M14.5 7.5L3.5 7.5" stroke={colorOrPrimary} strokeLinecap="round" />
					<path d="M14.5 10.5L3.5 10.5" stroke={colorOrPrimary} strokeLinecap="round" />
					<path d="M14.5 4.5L3.5 4.5" stroke={colorOrPrimary} strokeLinecap="round" />
					<path d="M14.5 13.5L3.5 13.5" stroke={colorOrPrimary} strokeLinecap="round" />
					<rect x="0.5" y="0.5" width="17" height="17" rx="2.5" stroke={colorOrPrimary} />
				</svg>
			);

		case "logout":
			return (
				<svg
					width={size || 18}
					height={size || 18}
					viewBox="0 0 18 18"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M11.3594 5.50543V4.79721C11.3594 3.25248 10.1069 2 8.56221 2H4.86169C3.31773 2 2.06525 3.25248 2.06525 4.79721V13.2458C2.06525 14.7905 3.31773 16.043 4.86169 16.043H8.5698C10.11 16.043 11.3594 14.7943 11.3594 13.2541V12.5383"
						stroke={colorOrPrimary}
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M16.5162 9.02148H7.37616"
						stroke={colorOrPrimary}
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M14.2934 6.80859L16.516 9.02131L14.2934 11.2348"
						stroke={colorOrPrimary}
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
			);

		// General
		case "infoWarning":
			return (
				<svg
					width={size || "14"}
					height={size || "14"}
					viewBox="0 0 14 14"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M7.00002 12.8333C10.2217 12.8333 12.8334 10.2216 12.8334 6.99996C12.8334 3.7783 10.2217 1.16663 7.00002 1.16663C3.77836 1.16663 1.16669 3.7783 1.16669 6.99996C1.16669 10.2216 3.77836 12.8333 7.00002 12.8333Z"
						stroke={colorOrPrimary}
						strokeWidth="1.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M7.75 4.66663C7.75 4.25241 7.41421 3.91663 7 3.91663C6.58579 3.91663 6.25 4.25241 6.25 4.66663H7.75ZM6.25 8.16663C6.25 8.58084 6.58579 8.91663 7 8.91663C7.41421 8.91663 7.75 8.58084 7.75 8.16663H6.25ZM6.25 4.66663V8.16663H7.75V4.66663H6.25Z"
						fill={colorOrPrimary}
					/>
					<path
						d="M7.75 10.0264C7.75 9.61215 7.41421 9.27637 7 9.27637C6.58579 9.27637 6.25 9.61215 6.25 10.0264L7.75 10.0264ZM6.25 10.0614C6.25 10.4756 6.58579 10.8114 7 10.8114C7.41421 10.8114 7.75 10.4756 7.75 10.0614L6.25 10.0614ZM6.25 10.0264L6.25 10.0614L7.75 10.0614L7.75 10.0264L6.25 10.0264Z"
						fill={colorOrPrimary}
					/>
				</svg>
			);

		case "infoSuccess":
			return (
				<svg
					width={size || "14"}
					height={size || "14"}
					viewBox="0 0 14 14"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<g clipPath="url(#clip0_13856_14098)">
						<path
							d="M6.99999 12.8334C10.2216 12.8334 12.8333 10.2217 12.8333 7.00008C12.8333 3.77842 10.2216 1.16675 6.99999 1.16675C3.77833 1.16675 1.16666 3.77842 1.16666 7.00008C1.16666 10.2217 3.77833 12.8334 6.99999 12.8334Z"
							stroke={colorOrPrimary}
							strokeWidth="1.5"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
						<path
							d="M5.24481 7.375L6.33572 8.5L9.24481 5.5"
							stroke={colorOrPrimary}
							strokeWidth="1.5"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</g>
					<defs>
						<clipPath id="clip0_13856_14098">
							<rect width="14" height="14" fill="white" />
						</clipPath>
					</defs>
				</svg>
			);

		// Pagination
		case "paginationRight":
			return (
				<svg
					width={size || "14"}
					height={size || "14"}
					viewBox="0 0 14 14"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path d="M5 2L10 7L5 12" stroke={colorOrPrimary} strokeWidth="2" />
				</svg>
			);

		// Inputs
		case "search":
			return (
				<svg
					width={size || "14"}
					height={size || "14"}
					viewBox="0 0 14 14"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M10.6571 10.8057L12.8571 12.9999"
						stroke={colorOrPrimary}
						strokeWidth="1.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M6.75431 12.2229C9.85342 12.2229 12.3657 9.71053 12.3657 6.61143C12.3657 3.51232 9.85342 1 6.75431 1C3.6552 1 1.14288 3.51232 1.14288 6.61143C1.14288 9.71053 3.6552 12.2229 6.75431 12.2229Z"
						stroke={colorOrPrimary}
						strokeWidth="1.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
			);

		case "clear":
			return (
				<svg
					width={size || "14"}
					height={size || "14"}
					viewBox="0 0 14 14"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M3.7087 2.4855C3.88942 2.1843 4.21493 2 4.56619 2H12C12.5523 2 13 2.44772 13 3V11C13 11.5523 12.5523 12 12 12H4.56619C4.21493 12 3.88942 11.8157 3.7087 11.5145L1.3087 7.5145C1.11869 7.19781 1.11869 6.80219 1.3087 6.4855L3.7087 2.4855Z"
						fill={colorOrPrimary}
					/>
					<rect
						x="5.54724"
						y="5.21436"
						width="1.01014"
						height="6.06085"
						transform="rotate(-45 5.54724 5.21436)"
						fill={Color.white}
					/>
					<rect
						x="6.26154"
						y="9.49976"
						width="1.01014"
						height="6.06085"
						transform="rotate(-135 6.26154 9.49976)"
						fill={Color.white}
					/>
				</svg>
			);

		case "dropdown":
			return (
				<svg
					width={size || "14"}
					height={size || "14"}
					viewBox="0 0 14 14"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path d="M12 5L7 10L2 5" stroke={colorOrPrimary} strokeWidth="2" />
				</svg>
			);

		case "email":
			return (
				<svg
					width={size || "14"}
					height={size || "14"}
					viewBox="0 0 14 14"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M11.6708 3H2.32917C2.14737 3 2 3.16403 2 3.36638V10.6336C2 10.836 2.14737 11 2.32917 11H11.6708C11.8526 11 12 10.836 12 10.6336V3.36638C12 3.16403 11.8526 3 11.6708 3Z"
						stroke={colorOrPrimary}
						strokeMiterlimit="10"
					/>
					<path
						d="M2 3L6.3753 6.50024C6.74052 6.79242 7.25948 6.79242 7.6247 6.50024L12 3"
						stroke={colorOrPrimary}
						strokeMiterlimit="10"
					/>
				</svg>
			);

		case "eyeOff":
			return (
				<svg
					width={size || "14"}
					height={size || "14"}
					viewBox="0 0 14 14"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M11.1367 5.06728C11.9914 5.83214 12.638 6.64593 12.9822 7.12347C12.9938 7.139 13 7.15785 13 7.17722C13 7.19658 12.9938 7.21543 12.9822 7.23097C12.1947 8.32596 9.82719 11.1785 6.99969 11.1785C6.40459 11.1785 5.82977 11.052 5.28571 10.8421M9.14286 3.7003C8.47516 3.38164 7.75363 3.17847 6.99969 3.17847C4.17469 3.17847 1.80219 6.03347 1.01719 7.12847C1.00603 7.14322 1 7.16122 1 7.17972C1 7.19821 1.00603 7.21621 1.01719 7.23097C1.37478 7.72864 2.06129 8.59205 2.97012 9.38472"
						stroke={colorOrPrimary}
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M5.42525 7.46425C5.40852 7.37149 5.39978 7.27595 5.39978 7.17837C5.39978 6.29471 6.11612 5.57837 6.99978 5.57837C7.04945 5.57837 7.09858 5.58063 7.14709 5.58506M8.58307 7.41042C8.48234 8.10377 7.93696 8.65303 7.24552 8.75961"
						stroke={colorOrPrimary}
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M2.36074 11.3964C2.16548 11.5917 2.16548 11.9083 2.36074 12.1036C2.556 12.2988 2.87259 12.2988 3.06785 12.1036L2.36074 11.3964ZM12.0678 3.10355C12.2631 2.90829 12.2631 2.59171 12.0678 2.39645C11.8726 2.20118 11.556 2.20118 11.3607 2.39645L12.0678 3.10355ZM3.06785 12.1036L12.0678 3.10355L11.3607 2.39645L2.36074 11.3964L3.06785 12.1036Z"
						fill={colorOrPrimary}
					/>
				</svg>
			);

		case "eyeOn":
			return (
				<svg
					width={size || "14"}
					height={size || "14"}
					viewBox="0 0 14 14"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M12.9822 7.05632C12.9938 7.03968 13 7.01948 13 6.99873C13 6.97798 12.9938 6.95778 12.9822 6.94114C12.1947 5.77061 9.82469 2.71436 6.99969 2.71436C4.17469 2.71436 1.80219 5.77328 1.01719 6.9465C1.00603 6.96231 1 6.98159 1 7.00141C1 7.02123 1.00603 7.04051 1.01719 7.05632C1.80219 8.22686 4.17219 11.2858 6.99969 11.2858C9.82719 11.2858 12.1947 8.22953 12.9822 7.05632Z"
						stroke={colorOrPrimary}
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M6.99996 8.71397C7.88362 8.71397 8.59996 7.94646 8.59996 6.99969C8.59996 6.05291 7.88362 5.2854 6.99996 5.2854C6.11631 5.2854 5.39996 6.05291 5.39996 6.99969C5.39996 7.94646 6.11631 8.71397 6.99996 8.71397Z"
						stroke={colorOrPrimary}
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
			);

		case "expandDown":
			return (
				<svg
					width={size || "14"}
					height={size || "14"}
					viewBox="0 0 14 14"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M6.63585 10.0256C6.83255 10.23 7.15973 10.23 7.35643 10.0256L11.3776 5.84669C11.6832 5.52903 11.4581 5 11.0173 5L2.975 5C2.53417 5 2.30905 5.52904 2.61471 5.84669L6.63585 10.0256Z"
						fill={colorOrPrimary}
					/>
				</svg>
			);

		case "expandUp":
			return (
				<svg
					width={size || "14"}
					height={size || "14"}
					viewBox="0 0 14 14"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M6.63585 3.97442C6.83255 3.77001 7.15973 3.77001 7.35643 3.97442L11.3776 8.15331C11.6832 8.47097 11.4581 9 11.0173 9H2.975C2.53417 9 2.30905 8.47096 2.61471 8.15331L6.63585 3.97442Z"
						fill={colorOrPrimary}
					/>
				</svg>
			);

		case "zoomIn":
			return (
				<svg
					width={size || "18"}
					height={size || "18"}
					viewBox="0 0 18 18"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M8.78998 10.54L8.78998 7.04"
						stroke={colorOrPrimary}
						strokeWidth="1.2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M7.03995 8.79004H10.54"
						stroke={colorOrPrimary}
						strokeWidth="1.2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M16 16.0001L14.6 14.6001"
						stroke={colorOrPrimary}
						strokeWidth="1.2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M8.40696 15.3C12.0796 15.3 15.057 12.3227 15.057 8.65C15.057 4.9773 12.0796 2 8.40696 2C4.73426 2 1.75696 4.9773 1.75696 8.65C1.75696 12.3227 4.73426 15.3 8.40696 15.3Z"
						stroke={colorOrPrimary}
						strokeWidth="1.2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
			);

		case "zoomOut":
			return (
				<svg
					width={size || "18"}
					height={size || "18"}
					viewBox="0 0 18 18"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M7.03998 8.79004H10.54"
						stroke={colorOrPrimary}
						strokeWidth="1.2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M8.65 15.3C12.3227 15.3 15.3 12.3227 15.3 8.65C15.3 4.9773 12.3227 2 8.65 2C4.9773 2 2 4.9773 2 8.65C2 12.3227 4.9773 15.3 8.65 15.3Z"
						stroke={colorOrPrimary}
						strokeWidth="1.2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M16 16.0001L14.6 14.6001"
						stroke={colorOrPrimary}
						strokeWidth="1.2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
			);

		case "checkmark":
			return (
				<svg
					width={size || 14}
					height={size || 14}
					viewBox="0 0 14 14"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M3.5 6.53317L6.125 9.33317L10.5 4.6665"
						stroke={colorOrPrimary}
						strokeWidth="1.5"
					/>
				</svg>
			);

		case "delete":
			return (
				<svg
					width={size || 14}
					height={size || 14}
					viewBox="0 0 14 14"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M9.355 11.9999H4.645C4.1355 11.9999 3.7075 11.6669 3.651 11.2264L2.75 4.17383H11.25L10.349 11.2264C10.2925 11.6669 9.8645 11.9999 9.355 11.9999Z"
						fill={colorOrPrimary}
					/>
					<path
						d="M11.5 3.30438H2.5C2.224 3.30438 2 3.1096 2 2.8696C2 2.6296 2.224 2.43481 2.5 2.43481H11.5C11.776 2.43481 12 2.6296 12 2.8696C12 3.1096 11.776 3.30438 11.5 3.30438Z"
						fill={colorOrPrimary}
					/>
					<path
						d="M8.5 2.86957H5.5V2.43478C5.5 2.19478 5.724 2 6 2H8C8.276 2 8.5 2.19478 8.5 2.43478V2.86957Z"
						fill={colorOrPrimary}
					/>
				</svg>
			);

		case "filter":
			return (
				<svg
					width={size || 14}
					height={size || 14}
					viewBox="0 0 14 14"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M2.91668 3H11.0834C11.2444 3 11.375 3.13058 11.375 3.29167C11.375 3.35477 11.3545 3.41618 11.3167 3.46667L8.16668 7.66667V12.4447C8.16668 12.6058 8.0361 12.7364 7.87502 12.7364C7.82974 12.7364 7.78508 12.7259 7.74458 12.7056L5.83335 11.75V7.66667L2.68335 3.46667C2.5867 3.3378 2.61282 3.15498 2.74168 3.05833C2.79217 3.02047 2.85358 3 2.91668 3Z"
						fill={colorOrPrimary}
					/>
				</svg>
			);

		case "arrange":
			return (
				<svg
					width={size || 14}
					height={size || 14}
					viewBox="0 0 14 14"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<rect x="3.99835" y="2.00244" width="2" height="2" rx="0.2" fill={colorOrPrimary} />
					<rect x="3.99835" y="6" width="2" height="2" rx="0.2" fill={colorOrPrimary} />
					<rect x="3.99835" y="9.99805" width="2" height="2" rx="0.2" fill={colorOrPrimary} />
					<rect x="8.00165" y="2.00244" width="2" height="2" rx="0.2" fill={colorOrPrimary} />
					<rect x="8.00165" y="6" width="2" height="2" rx="0.2" fill={colorOrPrimary} />
					<rect x="8.00165" y="9.99805" width="2" height="2" rx="0.2" fill={colorOrPrimary} />
				</svg>
			);

		// Checkboxes
		case "checkboxOn":
			return (
				<svg
					width={size || "14"}
					height={size || "14"}
					viewBox="0 0 14 14"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<rect
						x="0.5"
						y="0.5"
						width="13"
						height="13"
						rx="1.5"
						fill={colorOrPrimary}
						stroke={colorOrPrimary}
					/>
					<path
						d="M3.5 6.53341L6.125 9.33341L10.5 4.66675"
						stroke={Color.white}
						strokeWidth="1.5"
					/>
				</svg>
			);

		case "checkboxOff":
			return (
				<svg
					width={size || "14"}
					height={size || "14"}
					viewBox="0 0 14 14"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<rect
						x="0.5"
						y="0.5"
						width="13"
						height="13"
						rx="1.5"
						fill={Color.white}
						stroke={colorOrPrimary}
					/>
				</svg>
			);

		// Modals
		case "close":
			return (
				<svg
					width={size || "18"}
					height={size || "18"}
					viewBox="0 0 18 18"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<rect
						width="1.98124"
						height="17.8178"
						transform="matrix(0.707345 0.706868 -0.707345 0.706868 14.6069 2.00146)"
						fill={colorOrPrimary}
					/>
					<rect
						width="1.98124"
						height="17.8178"
						transform="matrix(-0.707345 0.706868 0.707345 0.706868 3.39307 2.00146)"
						fill={colorOrPrimary}
					/>
				</svg>
			);

		case "maximize":
			return (
				<svg
					width={size || "18"}
					height={size || "18"}
					viewBox="0 0 18 18"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M2 10H4V12.6L6.59851 10.0015L7.99851 11.4015L5.39998 14L8 14V16H4H2V14V10Z"
						fill={colorOrPrimary}
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M10 4V2H14H16V4V8H14V5.40002L11.4015 7.99854L10.0015 6.59853L12.6 4L10 4Z"
						fill={colorOrPrimary}
					/>
				</svg>
			);

		case "shrink":
			return (
				<svg
					width={size || "18"}
					height={size || "18"}
					viewBox="0 0 18 18"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M10 2H12V4.59998L14.5985 2.00146L15.9985 3.40147L13.4 6L16 6V8H12H10V6V2Z"
						fill={colorOrPrimary}
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M2 12V10H6H8V12V16H6V13.4L3.40149 15.9985L2.00149 14.5985L4.60002 12L2 12Z"
						fill={colorOrPrimary}
					/>
				</svg>
			);

		case "modalAlert":
			return (
				<svg
					width={size || "40"}
					height={size || "40"}
					viewBox="0 0 40 40"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40Z"
						fill={Color.redDisabled}
					/>
					<path
						d="M34.5422 28.1814L20.8196 6.06456C20.6598 5.80655 20.3781 5.6499 20.0749 5.6499C19.7714 5.6499 19.4898 5.80689 19.3299 6.06456L5.57023 28.242C5.40253 28.5123 5.39401 28.8525 5.54905 29.1304C5.7035 29.4083 5.99721 29.5808 6.3149 29.5808H33.8355H33.8393C34.3234 29.5808 34.7156 29.1882 34.7156 28.7044C34.715 28.5082 34.6509 28.3276 34.5422 28.1814Z"
						fill={Color.red}
					/>
					<path
						d="M19.0591 20.4343L18.7746 16.1772C18.7213 15.3475 18.695 14.7519 18.695 14.3907C18.695 13.899 18.8239 13.5153 19.0812 13.2399C19.3389 12.9636 19.6787 12.8262 20.0991 12.8262C20.6088 12.8262 20.9498 13.0024 21.1213 13.3549C21.2928 13.7076 21.379 14.2161 21.379 14.879C21.379 15.2702 21.3582 15.6678 21.3172 16.0698L20.9347 20.4517C20.8934 20.9733 20.8046 21.3731 20.6679 21.652C20.5315 21.9302 20.306 22.0692 19.9923 22.0692C19.6721 22.0692 19.4501 21.935 19.326 21.665C19.2012 21.3958 19.1122 20.9853 19.0591 20.4343ZM20.0457 26.2824C19.6841 26.2824 19.3683 26.1658 19.0992 25.9318C18.8295 25.6981 18.695 25.3707 18.695 24.95C18.695 24.5825 18.8239 24.2698 19.0812 24.0117C19.3389 23.7541 19.6547 23.6252 20.028 23.6252C20.4016 23.6252 20.7193 23.7537 20.9834 24.0117C21.247 24.2694 21.379 24.5824 21.379 24.95C21.379 25.3647 21.2458 25.6903 20.9785 25.9275C20.712 26.1639 20.4012 26.2824 20.0457 26.2824Z"
						fill={Color.white}
					/>
				</svg>
			);

		// Inputs
		case "add":
			return (
				<svg
					width={size || 14}
					height={size || 14}
					viewBox="0 0 14 14"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<rect x="6" y="2" width="2" height="10" fill={colorOrPrimary} />
					<rect x="2" y="6" width="10" height="2" fill={colorOrPrimary} />
				</svg>
			);

		case "remove":
			return (
				<svg
					width={size || 14}
					height={size || 14}
					viewBox="0 0 14 14"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<rect x="2" y="6" width="10" height="2" fill={colorOrPrimary} />
				</svg>
			);

		// Toasts
		case "toastSuccess":
			return (
				<svg
					width={size || 18}
					height={size || 18}
					viewBox="0 0 18 18"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
						fill={color || Color.toastSuccess}
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M13.2787 6.21802C13.5725 6.51 13.574 6.98487 13.282 7.27868L8.06459 12.5287C7.9238 12.6703 7.73233 12.75 7.53261 12.75C7.33289 12.75 7.14141 12.6703 7.00063 12.5287L4.71802 10.2318C4.42604 9.938 4.42752 9.46312 4.72132 9.17115C5.01513 8.87917 5.49 8.88065 5.78198 9.17445L7.53261 10.936L12.218 6.22132C12.51 5.92752 12.9849 5.92604 13.2787 6.21802Z"
						fill={Color.white}
					/>
				</svg>
			);

		case "toastPending":
			return (
				<svg
					width={size || 18}
					height={size || 18}
					viewBox="0 0 18 18"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
						fill={color || Color.toastPending}
					/>
					<path
						d="M9.62376 4.00426C9.28122 3.96149 9 4.24639 9 4.59276C9 4.93912 9.28192 5.21443 9.62238 5.27149C11.3972 5.56899 12.75 7.11738 12.75 8.9828C12.75 11.061 11.0711 12.7457 9 12.7457C6.92893 12.7457 5.25 11.061 5.25 8.9828C5.25 8.54544 5.32422 8.11954 5.4666 7.7188C5.58253 7.39254 5.48064 7.01137 5.17942 6.84224C4.87819 6.6731 4.49327 6.77998 4.36373 7.10103C4.12513 7.69239 4 8.32889 4 8.9828C4 11.7537 6.23857 14 9 14C11.7614 14 14 11.7537 14 8.9828C14 6.42384 12.0908 4.31234 9.62376 4.00426Z"
						fill={Color.white}
					/>
				</svg>
			);

		case "toastWarning":
			return (
				<svg
					width={size || 18}
					height={size || 18}
					viewBox="0 0 18 18"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
						fill={color || Color.yellow}
					/>
					<path
						d="M9 5V10"
						stroke={Color.white}
						strokeWidth="1.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M9 12.7002L9 12.8002"
						stroke={Color.white}
						strokeWidth="1.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
			);

		case "toastError":
			return (
				<svg
					width={size || 18}
					height={size || 18}
					viewBox="0 0 18 18"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
						fill={Color.red}
					/>
					<path
						d="M12.75 9.7501C13.1642 9.75011 13.5 9.41432 13.5 9.0001C13.5 8.58588 13.1643 8.25015 12.7501 8.25014L5.25002 8.25014C4.83579 8.25014 4.50006 8.58587 4.50006 9.00009C4.50005 9.41431 4.83583 9.75009 5.25006 9.75009L12.75 9.7501Z"
						fill={Color.white}
					/>
				</svg>
			);

		// Loading
		case "loadingInline":
			return (
				<svg
					width={size || 30}
					height={size || 30}
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 24 24"
				>
					<path d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" fill={colorOrPrimary} />
				</svg>
			);

		// Files
		case "fileCSV":
			return (
				<svg
					width={size || 20}
					height={size || 25}
					viewBox="0 0 20 25"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<g mask="url(#mask0_15644_6767)">
						<path
							d="M4 25H16C18.2091 25 20 23.2091 20 21V8.37511C20 7.58561 19.6888 6.82793 19.1338 6.26638L13.822 0.891269C13.2584 0.320964 12.4899 0 11.6881 0H4C1.79086 0 0 1.79086 0 4V21C0 23.2091 1.79086 25 4 25Z"
							fill={colorOrPrimary}
						/>
						<path
							d="M5.753 18.3099C5.26555 18.3099 4.84712 18.2117 4.4977 18.0153C4.14829 17.8189 3.87868 17.5439 3.68888 17.1903C3.50339 16.8323 3.41064 16.4111 3.41064 15.9266C3.41064 15.4421 3.50339 15.023 3.68888 14.6694C3.87868 14.3159 4.14829 14.0409 4.4977 13.8444C4.84712 13.648 5.26555 13.5498 5.753 13.5498C6.0679 13.5498 6.35476 13.5956 6.61359 13.6873C6.87241 13.7746 7.09241 13.9034 7.27359 14.0736L6.95653 14.879C6.7581 14.7218 6.56829 14.6105 6.38712 14.545C6.21025 14.4796 6.00966 14.4468 5.78535 14.4468C5.35829 14.4468 5.03045 14.5756 4.80182 14.8331C4.57751 15.0863 4.46535 15.4508 4.46535 15.9266C4.46535 16.2409 4.51496 16.5093 4.61417 16.7319C4.7177 16.9546 4.86653 17.1248 5.06064 17.2427C5.25908 17.3562 5.50064 17.4129 5.78535 17.4129C6.00966 17.4129 6.21025 17.3802 6.38712 17.3147C6.56829 17.2492 6.7581 17.1379 6.95653 16.9808L7.27359 17.7861C7.09241 17.952 6.87241 18.0808 6.61359 18.1724C6.35476 18.2641 6.0679 18.3099 5.753 18.3099Z"
							fill="white"
						/>
						<path
							d="M9.51868 18.3099C9.15201 18.3099 8.80907 18.2641 8.48985 18.1724C8.17064 18.0808 7.89887 17.9542 7.67456 17.7927L7.97221 16.9939C8.11887 17.0942 8.27417 17.1794 8.43809 17.2492C8.60201 17.3191 8.77456 17.3736 8.95574 17.4129C9.13691 17.4478 9.32672 17.4653 9.52515 17.4653C9.83574 17.4653 10.0557 17.4173 10.1851 17.3212C10.3189 17.2252 10.3857 17.103 10.3857 16.9546C10.3857 16.8192 10.3404 16.7167 10.2499 16.6468C10.1636 16.5726 10.004 16.5093 9.77103 16.4569L9.0075 16.2998C8.58907 16.2125 8.27632 16.0641 8.06927 15.8546C7.86221 15.645 7.75868 15.3657 7.75868 15.0165C7.75868 14.7196 7.83633 14.4621 7.99162 14.2439C8.14691 14.0256 8.36476 13.8554 8.64515 13.7331C8.92985 13.6109 9.26201 13.5498 9.64162 13.5498C9.96515 13.5498 10.2671 13.5956 10.5475 13.6873C10.8279 13.779 11.0587 13.9099 11.2399 14.0802L10.9422 14.8266C10.7653 14.6825 10.5669 14.5756 10.3469 14.5058C10.1312 14.4316 9.88966 14.3944 9.62221 14.3944C9.34182 14.3944 9.12613 14.4446 8.97515 14.545C8.82848 14.6454 8.75515 14.7829 8.75515 14.9575C8.75515 15.0885 8.80044 15.1954 8.89103 15.2784C8.98162 15.3569 9.14123 15.4202 9.36985 15.4683L10.1204 15.6189C10.5475 15.7062 10.8646 15.8524 11.0716 16.0575C11.2787 16.2627 11.3822 16.5355 11.3822 16.876C11.3822 17.1641 11.3046 17.4151 11.1493 17.629C10.9983 17.8429 10.7826 18.0109 10.5022 18.1331C10.2261 18.251 9.89829 18.3099 9.51868 18.3099Z"
							fill="white"
						/>
						<path
							d="M13.5339 18.2379L11.4827 13.6218H12.5698L13.9699 17.4746L14.1597 17.0049L15.3715 13.6218H16.4198L14.3686 18.2379H13.5339Z"
							fill="white"
						/>
						<path
							d="M14.5836 7.40768H20.0259C20.2044 7.40768 20.2935 7.19175 20.167 7.0659L12.5836 -0.479536V5.40768C12.5836 6.51225 13.4791 7.40768 14.5836 7.40768Z"
							fill="rgba(0,0,0,0.25)"
						/>
					</g>
				</svg>
			);

		// Small
		case "info":
			return (
				<svg
					width={size || 14}
					height={size || 14}
					viewBox="0 0 14 14"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<circle cx="7" cy="7" r="7" fill={colorOrPrimary} />
					<path
						d="M7 10.5L7 7"
						stroke={Color.white}
						strokeWidth="1.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M7.00432 4.19995L7 4.19995"
						stroke={Color.white}
						strokeWidth="1.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
			);

		// General
		case "settings":
			return (
				<svg
					width={size || 18}
					height={size || 18}
					viewBox="0 0 18 18"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M16.2819 6.49653C14.6537 6.49653 13.988 5.34385 14.7976 3.93002C15.2654 3.11054 14.9865 2.06593 14.1679 1.59766L12.6117 0.706132C11.901 0.282884 10.9835 0.535032 10.5607 1.24645L10.4618 1.41755C9.65217 2.83138 8.32084 2.83138 7.50225 1.41755L7.4033 1.24645C6.9985 0.535032 6.08096 0.282884 5.37031 0.706132L3.81409 1.59766C2.9955 2.06593 2.71664 3.11955 3.18441 3.93903C4.003 5.34385 3.33733 6.49653 1.70915 6.49653C0.773613 6.49653 0 7.26198 0 8.20753V9.79247C0 10.729 0.764618 11.5035 1.70915 11.5035C3.33733 11.5035 4.003 12.6561 3.18441 14.07C2.71664 14.8895 2.9955 15.9341 3.81409 16.4023L5.37031 17.2939C6.08096 17.7171 6.9985 17.465 7.42129 16.7536L7.52024 16.5825C8.32983 15.1686 9.66117 15.1686 10.4798 16.5825L10.5787 16.7536C11.0015 17.465 11.919 17.7171 12.6297 17.2939L14.1859 16.4023C15.0045 15.9341 15.2834 14.8805 14.8156 14.07C13.997 12.6561 14.6627 11.5035 16.2909 11.5035C17.2264 11.5035 18 10.738 18 9.79247V8.20753C17.991 7.27098 17.2264 6.49653 16.2819 6.49653ZM8.9955 11.9267C7.38531 11.9267 6.07196 10.6119 6.07196 9C6.07196 7.38805 7.38531 6.07328 8.9955 6.07328C10.6057 6.07328 11.919 7.38805 11.919 9C11.919 10.6119 10.6057 11.9267 8.9955 11.9267Z"
						fill={colorOrPrimary}
					/>
				</svg>
			);

		case "picture":
			return (
				<svg
					width={size || 14}
					height={size || 14}
					viewBox="0 0 14 14"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M10.0478 0C12.4117 0 14 1.6534 14 4.1216V9.8714C14 9.9771 13.9811 10.0716 13.9755 10.1738C13.972 10.2333 13.9727 10.2928 13.9678 10.3523C13.965 10.3789 13.9573 10.4034 13.9545 10.43C13.9314 10.6498 13.8957 10.8598 13.846 11.0635C13.8334 11.1181 13.8187 11.1706 13.804 11.2238C13.748 11.4212 13.6822 11.6095 13.6031 11.7894C13.58 11.8398 13.5548 11.8881 13.531 11.9378C13.4456 12.1093 13.3532 12.2738 13.2461 12.4264L13.1425 12.5608C13.0312 12.705 12.915 12.8429 12.7834 12.9682C12.7407 13.0088 12.6924 13.0438 12.6476 13.0823C12.5125 13.1985 12.3746 13.3098 12.2227 13.405C12.1681 13.4393 12.1079 13.4645 12.0519 13.4953C11.8972 13.5807 11.7411 13.664 11.571 13.7284C11.501 13.755 11.4233 13.769 11.3505 13.7921C11.1832 13.8439 11.018 13.8978 10.8381 13.9286C10.7928 13.9365 10.7462 13.9421 10.699 13.9465L10.4118 13.9671C10.29 13.9762 10.1745 14 10.0478 14H3.9466C3.6834 14 3.4321 13.9734 3.1892 13.9335C3.1801 13.9321 3.1717 13.9307 3.1633 13.9293C2.2162 13.7662 1.4301 13.3091 0.8792 12.6196C0.8729 12.6196 0.8729 12.6126 0.8666 12.6063C0.3129 11.9091 0 10.9718 0 9.8714V4.1216C0 1.6534 1.5897 0 3.9466 0H10.0478ZM10.0478 0.9765H3.9466C2.1427 0.9765 0.9772 2.2134 0.9772 4.1216V9.8714C0.9772 10.4069 1.0766 10.885 1.2467 11.2987C1.2684 11.2728 2.6243 9.6194 2.6306 9.6138C3.115 9.0608 4.0243 8.2362 5.2178 8.7353C5.5048 8.8543 5.7568 9.0216 5.9878 9.1686C6.3889 9.4367 6.6248 9.5627 6.8698 9.5417C6.9713 9.5277 7.0665 9.4976 7.1568 9.4416C7.5474 9.2008 8.6513 7.5908 8.7178 7.5033C9.4808 6.5093 10.6568 6.2433 11.6368 6.8313C11.7026 6.8705 11.9712 7.05477 12.2624 7.26232L12.4822 7.42045C12.7007 7.57913 12.9064 7.73377 13.0235 7.833V4.1216C13.0235 2.2134 11.858 0.9765 10.0478 0.9765ZM4.5355 2.79972C5.02387 2.79972 5.46612 3.00509 5.78288 3.33273C6.101 3.64888 6.30042 4.08461 6.30042 4.56019C6.30042 5.50866 5.50682 6.29972 4.55381 6.29972C3.71612 6.29972 3.00187 5.68768 2.8418 4.89526C2.81534 4.77637 2.80042 4.65409 2.80042 4.52776C2.80042 3.57254 3.57639 2.79972 4.5355 2.79972Z"
						fill={colorOrPrimary}
					/>
				</svg>
			);

		case "tooltip":
			return (
				<svg
					width={size || 14}
					height={size || 14}
					viewBox="0 0 14 14"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<rect x="1" y="2.71436" width="12" height="9.42857" rx="3" fill={colorOrPrimary} />
					<path
						d="M5.18164 2.81836L6.29281 1.70719C6.68333 1.31667 7.3165 1.31667 7.70702 1.70719L8.81819 2.81836L6.99992 4.63663L5.18164 2.81836Z"
						fill={colorOrPrimary}
					/>
					<rect
						x="2.71436"
						y="7"
						width="4.28571"
						height="0.857143"
						rx="0.428571"
						fill={Color.white}
					/>
					<rect
						x="2.71436"
						y="8.71436"
						width="6.85714"
						height="0.857143"
						rx="0.428571"
						fill={Color.white}
					/>
				</svg>
			);

		case "mudmap":
			return (
				<svg
					width={size || 18}
					height={size || 18}
					viewBox="0 0 18 18"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<rect x="1.5" y="5" width="1" height="8" rx="0.5" fill={colorOrPrimary} />
					<rect x="15.5" y="5" width="1" height="8" rx="0.5" fill={colorOrPrimary} />
					<rect x="3.5" y="3" width="11" height="12" rx="2" fill={colorOrPrimary} />
				</svg>
			);

		case "planogram":
			return (
				<svg
					width={size || 14}
					height={size || 14}
					viewBox="0 0 14 14"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M3.5225 0.0238193C3.79857 -0.00141922 4.025 0.225558 4.025 0.502786V3.56C4.025 3.83614 3.80114 4.06 3.525 4.06H0.5C0.223857 4.06 -0.00265701 3.83533 0.0205932 3.56017C0.194902 1.49726 1.46749 0.211685 3.5225 0.0238193Z"
						fill={colorOrPrimary}
					/>
					<path
						d="M13.9794 3.56017C14.0027 3.83533 13.7761 4.06 13.5 4.06H10.475C10.1989 4.06 9.97501 3.83614 9.97501 3.56V0.502786C9.97501 0.225558 10.2014 -0.00141923 10.4775 0.0238193C12.5325 0.211685 13.8051 1.49726 13.9794 3.56017Z"
						fill={colorOrPrimary}
					/>
					<path
						d="M13.4943 10.0105C13.7727 10.0105 14.0001 10.2388 13.9729 10.5158C13.7741 12.5346 12.5091 13.7912 10.4776 13.9767C10.2015 14.0019 9.97501 13.7749 9.97501 13.4977V10.5105C9.97501 10.2344 10.1989 10.0105 10.475 10.0105H13.4943Z"
						fill={colorOrPrimary}
					/>
					<path
						d="M3.525 10.0105C3.80114 10.0105 4.025 10.2344 4.025 10.5105V13.4977C4.025 13.7749 3.79854 14.0019 3.52245 13.9767C1.49089 13.7912 0.225906 12.5346 0.0271499 10.5158C-0.000120878 10.2388 0.227321 10.0105 0.505666 10.0105H3.525Z"
						fill={colorOrPrimary}
					/>
					<path
						d="M4.025 5.6106C4.025 5.33445 3.80114 5.1106 3.525 5.1106H0.5C0.223857 5.1106 0 5.33445 0 5.6106V8.46061C0 8.73675 0.223858 8.96061 0.5 8.96061H3.525C3.80114 8.96061 4.025 8.73675 4.025 8.46061V5.6106Z"
						fill={colorOrPrimary}
					/>
					<path
						d="M14 5.6106C14 5.33445 13.7761 5.1106 13.5 5.1106H10.475C10.1989 5.1106 9.97501 5.33445 9.97501 5.6106V8.46061C9.97501 8.73675 10.1989 8.96061 10.475 8.96061H13.5C13.7761 8.96061 14 8.73675 14 8.46061V5.6106Z"
						fill={colorOrPrimary}
					/>
					<path
						d="M8.925 5.6106C8.925 5.33445 8.70114 5.1106 8.425 5.1106H5.575C5.29885 5.1106 5.075 5.33445 5.075 5.6106V8.46061C5.075 8.73675 5.29885 8.96061 5.575 8.96061H8.425C8.70114 8.96061 8.925 8.73675 8.925 8.46061V5.6106Z"
						fill={colorOrPrimary}
					/>
					<path
						d="M8.925 0.5C8.925 0.223858 8.70114 0 8.425 0H5.575C5.29885 0 5.075 0.223858 5.075 0.5V3.56C5.075 3.83614 5.29885 4.06 5.575 4.06H8.425C8.70114 4.06 8.925 3.83614 8.925 3.56V0.5Z"
						fill={colorOrPrimary}
					/>
					<path
						d="M8.925 10.5105C8.925 10.2344 8.70114 10.0105 8.425 10.0105H5.575C5.29885 10.0105 5.075 10.2344 5.075 10.5105V13.5005C5.075 13.7766 5.29885 14.0005 5.575 14.0005H8.425C8.70114 14.0005 8.925 13.7766 8.925 13.5005V10.5105Z"
						fill={colorOrPrimary}
					/>
				</svg>
			);

		case "pogger":
			return (
				<svg
					width={size || 14}
					height={size || 14}
					viewBox="0 0 14 14"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M8.18807 4.44995H5.80607C5.05609 4.44995 4.44409 5.05595 4.44409 5.81195V8.19395C4.44409 8.94395 5.05009 9.55595 5.80607 9.55595H8.18807C8.93807 9.55595 9.55007 8.94995 9.55007 8.19395V5.81195C9.55007 5.05595 8.94407 4.44995 8.18807 4.44995ZM7.90007 7.58795L7.36607 8.51795C7.28807 8.65595 7.14407 8.72795 7.00007 8.72795C6.92807 8.72795 6.85007 8.70995 6.79007 8.67395C6.58607 8.55995 6.51407 8.30195 6.63407 8.09795L7.01807 7.43195H6.68207C6.41207 7.43195 6.19007 7.31195 6.07007 7.10795C5.95007 6.90395 5.96207 6.65195 6.10007 6.41795L6.63407 5.48795C6.75407 5.28395 7.01207 5.21795 7.21007 5.33195C7.41407 5.44595 7.48607 5.70395 7.36607 5.90795L6.98207 6.57395H7.31807C7.58807 6.57395 7.81007 6.69395 7.93007 6.89795C8.05007 7.10195 8.03807 7.35395 7.90007 7.58795Z"
						fill={colorOrPrimary}
					/>
					<rect x="5.72925" y="4.99243" width="2.81313" height="4.02079" fill={colorOrPrimary} />
					<path
						d="M12.55 7.45C12.802 7.45 13 7.246 13 7C13 6.748 12.802 6.55 12.55 6.55H11.8V5.23H12.55C12.802 5.23 13 5.032 13 4.78C13 4.534 12.802 4.33 12.55 4.33H11.662C11.374 3.376 10.624 2.626 9.67 2.338V1.45C9.67 1.204 9.466 1 9.22 1C8.974 1 8.77 1.204 8.77 1.45V2.2H7.45V1.45C7.45 1.204 7.246 1 7 1C6.754 1 6.55 1.204 6.55 1.45V2.2H5.236V1.45C5.236 1.204 5.032 1 4.786 1C4.534 1 4.336 1.204 4.336 1.45V2.338C3.376 2.626 2.626 3.376 2.338 4.33H1.45C1.204 4.33 1 4.534 1 4.78C1 5.032 1.204 5.23 1.45 5.23H2.2V6.55H1.45C1.204 6.55 1 6.748 1 7C1 7.246 1.204 7.45 1.45 7.45H2.2V8.77H1.45C1.204 8.77 1 8.968 1 9.22C1 9.466 1.204 9.67 1.45 9.67H2.338C2.62 10.624 3.376 11.374 4.336 11.662V12.55C4.336 12.796 4.534 13 4.786 13C5.032 13 5.236 12.796 5.236 12.55V11.8H6.556V12.55C6.556 12.796 6.754 13 7.006 13C7.252 13 7.456 12.796 7.456 12.55V11.8H8.77V12.55C8.77 12.796 8.974 13 9.22 13C9.466 13 9.67 12.796 9.67 12.55V11.662C10.624 11.374 11.374 10.624 11.662 9.67H12.55C12.802 9.67 13 9.466 13 9.22C13 8.968 12.802 8.77 12.55 8.77H11.8V7.45H12.55ZM10.156 8.356C10.156 9.346 9.346 10.156 8.356 10.156H5.644C4.654 10.156 3.844 9.346 3.844 8.356V5.644C3.844 4.654 4.654 3.844 5.644 3.844H8.356C9.346 3.844 10.156 4.654 10.156 5.644V8.356Z"
						fill={colorOrPrimary}
					/>
				</svg>
			);

		case "segment":
			return (
				<svg
					width={size || 14}
					height={size || 14}
					viewBox="0 0 14 14"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M7 10.9V11.428C7 12.55 6.55 13 5.422 13H2.572C1.702 13 1 12.298 1 11.428V8.578C1 7.45 1.45 7 2.572 7H3.1V9.1C3.1 10.096 3.904 10.9 4.9 10.9H7Z"
						fill={colorOrPrimary}
					/>
					<path
						d="M10 7.9V8.422C10 9.292 9.292 10 8.422 10H5.572C4.45 10 4 9.55 4 8.422V5.572C4 4.702 4.702 4 5.572 4H6.1V6.1C6.1 7.096 6.904 7.9 7.9 7.9H10Z"
						fill={colorOrPrimary}
					/>
					<path
						d="M13 2.572V5.422C13 6.55 12.55 7 11.422 7H8.572C7.45 7 7 6.55 7 5.422V2.572C7 1.45 7.45 1 8.572 1H11.422C12.55 1 13 1.45 13 2.572Z"
						fill={colorOrPrimary}
					/>
				</svg>
			);

		case "merchant":
			return (
				<svg
					width={size || 14}
					height={size || 14}
					viewBox="0 0 14 14"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M0.830225 1.15889C0.694376 1.41163 0.627562 1.7234 0.493935 2.34695L0.0452657 4.44058C-0.238823 5.76623 0.847625 7.00304 2.2962 7.00304C3.47552 7.00304 4.46297 6.16904 4.58032 5.07389L4.6321 4.5906C4.50972 5.88522 5.60311 7.00304 6.99977 7.00304C8.40594 7.00304 9.5047 5.86995 9.36478 4.56414L9.41955 5.07389C9.5369 6.16904 10.5243 7.00304 11.7037 7.00304C13.1522 7.00304 14.2387 5.76623 13.9546 4.44058L13.5059 2.34695C13.3723 1.72341 13.3055 1.41162 13.1696 1.15889C12.8834 0.626347 12.3683 0.232273 11.7526 0.0747555C11.4605 0 11.1198 0 10.4384 0H8.87573H3.56146C2.8801 0 2.53941 0 2.24722 0.0747555C1.63154 0.232273 1.11647 0.626347 0.830225 1.15889Z"
						fill={colorOrPrimary}
					/>
					<path
						d="M11.7038 8.05349C12.317 8.05349 12.8866 7.90479 13.3783 7.64659V8.40366C13.3783 11.0447 13.3783 12.3652 12.4992 13.1856C11.7915 13.8461 10.7366 13.9749 8.87599 14V11.555C8.87599 10.9005 8.87599 10.5733 8.72519 10.3295C8.6264 10.1698 8.48431 10.0372 8.31321 9.94502C8.05202 9.80428 7.70136 9.80428 7.00004 9.80428C6.29872 9.80428 5.94806 9.80428 5.68687 9.94502C5.51576 10.0372 5.37367 10.1698 5.27488 10.3295C5.12408 10.5733 5.12408 10.9005 5.12408 11.555V14C3.26346 13.9749 2.2086 13.8461 1.50092 13.1856C0.621796 12.3652 0.621796 11.0447 0.621796 8.40366V7.64657C1.11347 7.90478 1.68313 8.05349 2.29633 8.05349C3.19458 8.05349 4.01815 7.72884 4.63209 7.1935C5.25291 7.72583 6.08194 8.05349 6.9999 8.05349C7.91792 8.05349 8.74702 7.72576 9.36787 7.19336C9.98183 7.72878 10.8055 8.05349 11.7038 8.05349Z"
						fill={colorOrPrimary}
					/>
				</svg>
			);

		case "rotate":
			return (
				<svg
					width={size || 8}
					height={size || 8}
					viewBox="0 0 8 8"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<rect x="0.5" y="5.5" width="7" height="2" stroke="white" strokeLinecap="square" />
					<path
						d="M6.59865 2.5C6.07994 1.6033 5.11042 1 4 1C2.47392 1 1.21398 2.13949 1.0246 3.61404M1.0246 3.61404C1.00837 3.7404 1 3.86923 1 4L1.0246 3.61404Z"
						stroke={colorOrPrimary}
						strokeLinecap="square"
					/>
					<path d="M7 1V3H5" stroke={colorOrPrimary} strokeLinecap="square" />
				</svg>
			);
	}

	// Needs to be unreachable
	return null;
};
